import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { FAQS } from '../lib/content';
import { Reveal } from './Reveal';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="w-full bg-navy-50/30 py-20 sm:py-28" data-id="element-46" data-mp="1gcpemvrj22q6">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-47" data-mp="1geiki8ubgix4">
        <Reveal className="text-center" data-id="element-48" data-mp="2e0pnjeaz237d">
          <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 font-display text-xs font-extrabold uppercase tracking-[0.14em] text-navy shadow-sm" data-id="element-49" data-mp="2dyda9eg5sh0n">
            ❓ Preguntas frecuentes
          </span>
          <h2 className="mt-6 font-black text-navy sm:text-5xl text-[40px] font-[Barlow,_sans-serif]" data-id="element-50" data-mp="1z3fh4jd6rnii">
            Dudas rápidas,
            <br data-id="element-51" data-mp="so64eaox3fvg" />
            <span className="text-orange" data-id="element-52" data-mp="soobk2d4bei5">respuestas claras</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg font-medium text-navy/70" data-id="element-53" data-mp="nmyx0cqosipb">
            Todo lo importante antes de empezar con Mini Constructores.
          </p>
        </Reveal>

        <div className="mt-12 space-y-4" data-id="element-54" data-mp="uhkbtlp493z0">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <Reveal key={faq.question} delay={i * 0.05} data-id="element-55" data-mp="fji9tfxqgqjv" data-mpi={i}>
                <div className={`overflow-hidden rounded-3xl border-2 bg-white transition-all duration-300 ${isOpen ? 'border-sky-100 shadow-card' : 'border-navy-50 shadow-soft'}`} data-id="element-56" data-mp="ki1xplvw0cev">
                  <h3 data-id="element-57" data-mp="bjzpal9tqhhk">
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left sm:px-8" data-id="element-58" data-mp="3sywr8aqsokga">
                      <span className="font-display text-base font-extrabold text-navy sm:text-lg" data-id="element-59" data-mp="3nys5o6b14zj7">
                        {faq.question}
                      </span>
                      <span className={`flex h-8 w-8 flex-none items-center justify-center rounded-full transition-all duration-300 ${isOpen ? 'rotate-45 bg-orange text-white' : 'bg-navy-50 text-navy'}`} aria-hidden="true" data-id="element-60" data-mp="1pp33i6vmn8ag">
                        <PlusIcon className="h-4 w-4" strokeWidth={3} data-id="element-61" data-mp="2ddclexppzbwb" />
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-62" data-mp="23ghrks4e5zod">
                    {isOpen ? <motion.div id={`faq-panel-${i}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.32,
                  ease: [0.22, 1, 0.36, 1]
                }} data-id="element-63" data-mp="1zgpbluco4r8z">
                        <p className="px-6 pb-6 text-[15px] leading-relaxed text-navy/70 sm:px-8" data-id="element-64" data-mp="33ppi7ukuor7j">
                          {faq.answer}
                        </p>
                      </motion.div> : null}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>

        <Reveal className="mt-16 text-center" data-id="element-65" data-mp="3idkdniq8t9ob">
          <span className="inline-block text-3xl" data-id="element-66" data-mp="3igygst6qdmwt">✨</span>
          <p className="mx-auto mt-4 max-w-xl text-lg font-medium text-navy/70" data-id="element-67" data-mp="3ncdn902esgj7">
            Comprás una vez y recibís el acceso completo para empezar hoy.
          </p>
        </Reveal>
      </div>
    </section>;
}